import { Badge, TagsInput } from '@mantine/core'
import type { TagsInputProps } from '@mantine/core'

export const KNOWN_SCOPES = [
  'read:applicants',
  'read:documents',
  'create:applicants',
]

const PILL_STYLES = {
  pill: {
    backgroundColor: 'var(--mantine-color-blue-light)',
    color: 'var(--mantine-color-blue-light-color)',
    fontWeight: 500,
  },
}

const ScopesInput = (props: Omit<TagsInputProps, 'data' | 'renderOption'>) => (
  <TagsInput
    data={KNOWN_SCOPES}
    styles={PILL_STYLES}
    renderOption={({ option }) => (
      <Badge size="sm" variant="light">
        {option.value}
      </Badge>
    )}
    {...props}
  />
)

export default ScopesInput
